var ajaxCalls = require('./ajaxCalls');
var stats = require('./stats');
var reviewFrame = require('./review_frame');
var insertChart = require('./insertChart');
var resultBoxFrame = require('./result_box');
var reviewDetail = require('./review_detail');

var _global = {};
var QuizReview = function(container,userId,examId,apiUrl,imageHost,modal) {
    _global.container = container;
    _global.modal = modal;
    _global.userId = userId;
    _global.examId = examId;
    _global.apiUrl = apiUrl;
    _global.imageHost = imageHost;
    _global.chapterOrder = [];
    _global.chapters = [];
    _global.all = { total: 0, correct : 0, incorrect : 0, skipped : 0, unseen: 0, answers : []};

    ajaxCalls.getQuiz(userId,examId,apiUrl,function(response) {
        stats(_global,response);
        //console.log(_global);
        var review = reviewFrame(_global);

        $(container).append(review);

        var canvasElement = $('.all-box canvas')[0];
        insertChart(canvasElement,_global.all,false);
        $(review).find('.all-detail').click(function() {
            reviewDetail(_global.modal, _global.all,'All Questions',_global.imageHost);
        });

        // since chapters start at 1 and is associative
        var order = [];
        _(_global.chapterOrder).each(function(chapter_name) {
            if (typeof chapter_name !== 'undefined') {
                order.push(chapter_name);
            }
        });

        // set up the first box next to all
        var CN = order[0];
        var boxId = 1;
        var box = resultBoxFrame(boxId,CN);

        $(review).find('.row:first-child .col-lg-12:first-child').append(box);
        var canvas = $(review).find('.chapter-box-'+ boxId +' canvas')[0];
        insertChart(canvas,_global.chapters[CN],false);

        for ( var i = 1; i < order.length; i++ ) {
            var string = '<div class="row">'+
                '</div>';
            var row = $.parseHTML(string);

            if (typeof order[i] !== 'undefined') {
                var name = order[i];
                var box = resultBoxFrame(i,name);
                $(row).append(box);

                var canvas = $(box).find('canvas')[0];
                insertChart(canvas,_global.chapters[name],false);

                i++;
            }
            if (typeof order[i] !== 'undefined') {
                var name = order[i];
                var box = resultBoxFrame(i,name);

                $(row).append(box);
                var canvas = $(box).find('canvas')[0];
                insertChart(canvas,_global.chapters[name],false);

                i++;
            }
            if (typeof order[i] !== 'undefined') {
                var name = order[i];
                var box = resultBoxFrame(i,name);
                $(row).append(box);
                var canvas = $(box).find('canvas')[0];
                insertChart(canvas,_global.chapters[name],false);

            }

            $(review).append(row);

        }

        $(review).find('.detail').click(function() {
            var name = $(this).attr('title');
            reviewDetail(_global.modal, _global.chapters[name],name,_global.imageHost);
        });

    }, false); // JayG Jun 30, 2023 #26230828 Add parameter for randomize

}

module.exports = QuizReview;


//////////////////
// WEBPACK FOOTER
// ./src/QuizReview.js
// module id = 329
// module chunks = 0